import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-grofvuil-ophalen',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconGrofvuilOphalen {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M9.12 9h3.91c.87 0 1.71-.51 1.98-1.35.44-1.38-.58-2.65-1.89-2.65H8.36c-.75 0-1.43.42-1.78 1.09L0 18.92l3.03 1.62z"/>
  <path d="M34 12q-1-2-2-2h-3.99V7a2 2 0 0 0-2-2h-9.49c.46.8.65 1.73.5 2.66-.31 1.91-2.05 3.34-4.05 3.34h-2.69L4.74 21.47a2.014 2.014 0 0 1-1.77 1.07c-.32 0-.63-.08-.91-.22v2.19c0 .83.67 1.5 1.5 1.5h1.51c-.02.17-.05.33-.05.5 0 2.48 2.02 4.5 4.49 4.5S14 28.99 14 26.51c0-.17-.03-.33-.05-.5h10.09c-.02.17-.05.33-.05.5 0 2.48 2.02 4.5 4.49 4.5s4.49-2.02 4.49-4.5c0-.17-.03-.33-.05-.5h1.05c1.1 0 2-.9 2-2v-7.76c0-.16-.04-.31-.11-.45l-1.89-3.79ZM9.56 29c-1.38 0-2.49-1.12-2.49-2.5S8.19 24 9.56 24s2.49 1.12 2.49 2.5S10.93 29 9.56 29m18.95 0c-1.38 0-2.49-1.12-2.49-2.5s1.12-2.5 2.49-2.5S31 25.12 31 26.5 29.88 29 28.51 29M34 17h-5.99v-5h4.03L34 16z"/>
</svg>

    );
  }
}
